import { getCurrentEnv } from '@utilities/helpers/core.helpers'

export const getCurrency = () => {
  const env = getCurrentEnv()
  if (env === 'RICKSHAW') return 'GBP'
  return 'EUR'
}
